import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var Calculate = function Calculate(props) {
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: style
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 2H6C4.3 2 3 3.3 3 5V19C3 20.7 4.3 22 6 22H17C18.7 22 20 20.7 20 19V5C20 3.3 18.7 2 17 2ZM18 19C18 19.6 17.6 20 17 20H6C5.4 20 5 19.6 5 19V5C5 4.4 5.4 4 6 4H17C17.6 4 18 4.4 18 5V19ZM16 7C16 7.6 15.6 8 15 8H8C7.4 8 7 7.6 7 7C7 6.4 7.4 6 8 6H15C15.6 6 16 6.4 16 7ZM11 17C11 17.6 10.6 18 10 18H8C7.4 18 7 17.6 7 17C7 16.4 7.4 16 8 16H10C10.6 16 11 16.4 11 17ZM16 17C16 17.6 15.6 18 15 18H13C12.4 18 12 17.6 12 17C12 16.4 12.4 16 13 16H15C15.6 16 16 16.4 16 17ZM11 14C11 14.6 10.6 15 10 15H8C7.4 15 7 14.6 7 14C7 13.4 7.4 13 8 13H10C10.6 13 11 13.4 11 14ZM16 14C16 14.6 15.6 15 15 15H13C12.4 15 12 14.6 12 14C12 13.4 12.4 13 13 13H15C15.6 13 16 13.4 16 14Z",
    fill: color
  }));
};

export { Calculate };
